import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid2';
import Chip from '@mui/material/Chip';
import { Translate, TextFormat } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './tour-step.reducer';

const FieldLabel = ({ children }: { children: React.ReactNode }) => (
  <Typography variant="body2" color="text.secondary" sx={{ mb: 0.5 }}>
    {children}
  </Typography>
);

const FieldValue = ({ children, sx }: { children: React.ReactNode; sx?: object }) => (
  <Typography variant="body1" sx={{ mb: 2, ...sx }}>
    {children || '-'}
  </Typography>
);

const BooleanDisplay = ({ value }: { value?: boolean }) =>
  value ? (
    <Chip icon={<FontAwesomeIcon icon="check" />} label="Yes" color="success" size="small" />
  ) : (
    <Chip icon={<FontAwesomeIcon icon="times" />} label="No" color="error" size="small" />
  );

export const TourStepDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const tourStepEntity = useAppSelector(state => state.tourStep.entity);
  return (
    <Box sx={{ maxWidth: 1200, mx: 'auto', mt: 4, p: 2 }}>
      <Box sx={{ mb: 4, display: 'flex', alignItems: 'center', gap: 2 }}>
        <h2 data-cy="tourStepDetailsHeading">
          <Translate contentKey="jhipsterSampleApplicationApp.tourStep.detail.title">TourStep</Translate>
        </h2>
        {tourStepEntity.id && (
          <Box sx={{ bgcolor: 'primary.light', color: 'primary.contrastText', px: 2, py: 0.5, borderRadius: 1, fontWeight: 'bold' }}>
            ID: {tourStepEntity.id}
          </Box>
        )}
      </Box>

      <Grid container spacing={3}>
        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourStep.code" />
          </FieldLabel>
          <FieldValue>{tourStepEntity.code}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourStep.enabled" />
          </FieldLabel>
          <BooleanDisplay value={tourStepEntity.enabled} />

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourStep.icon" />
          </FieldLabel>
          <FieldValue>{tourStepEntity.icon}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourStep.stepOrder" />
          </FieldLabel>
          <FieldValue>{tourStepEntity.stepOrder}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourStep.waitTime" />
          </FieldLabel>
          <FieldValue>{tourStepEntity.waitTime}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourStep.waitTimeMeasure" />
          </FieldLabel>
          <FieldValue>
            <Translate contentKey={`jhipsterSampleApplicationApp.DurationMeasure.${tourStepEntity.waitTimeMeasure}`} />
          </FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourStep.driveTime" />
          </FieldLabel>
          <FieldValue>{tourStepEntity.driveTime}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourStep.driveTimeMeasure" />
          </FieldLabel>
          <FieldValue>
            <Translate contentKey={`jhipsterSampleApplicationApp.DurationMeasure.${tourStepEntity.driveTimeMeasure}`} />
          </FieldValue>
        </Grid>

        <Grid size={{ xs: 12, md: 6 }}>
          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourStep.createdDate" />
          </FieldLabel>
          <FieldValue>
            {tourStepEntity.createdDate ? (
              <TextFormat value={tourStepEntity.createdDate} type="date" format={APP_LOCAL_DATE_FORMAT} />
            ) : null}
          </FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourStep.createdBy" />
          </FieldLabel>
          <FieldValue>{tourStepEntity.createdBy ? tourStepEntity.createdBy.login : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourStep.tour" />
          </FieldLabel>
          <FieldValue>{tourStepEntity.tour ? tourStepEntity.tour.code : ''}</FieldValue>

          <FieldLabel>
            <Translate contentKey="jhipsterSampleApplicationApp.tourStep.place" />
          </FieldLabel>
          <FieldValue>{tourStepEntity.place ? tourStepEntity.place.code : ''}</FieldValue>
        </Grid>

        <Grid size={12}>
          <Box sx={{ display: 'flex', gap: 2, mt: 3 }}>
            <Button
              component={Link}
              to="/tour-step"
              replace
              color="info"
              variant="outlined"
              startIcon={<FontAwesomeIcon icon="arrow-left" />}
            >
              <Translate contentKey="entity.action.back">Back</Translate>
            </Button>
            <Button
              component={Link}
              to={`/tour-step/${tourStepEntity.id}/edit`}
              replace
              color="primary"
              variant="contained"
              startIcon={<FontAwesomeIcon icon="pencil-alt" />}
            >
              <Translate contentKey="entity.action.edit">Edit</Translate>
            </Button>
          </Box>
        </Grid>
      </Grid>
    </Box>
  );
};

export default TourStepDetail;
